import $ from "jquery";
import "jquery-mask-plugin";

// Inizializzazione centralizzata dei controlli inputmask
export const initializeInputMasks = () => {
    // Esempio di maschera per un campo di input numerico
    $(".money").mask("000.000.000", { reverse: true });

    // Esempio di maschera per un campo di input data
    $(".date").mask("00/00/0000");

    // Esempio di maschera per un campo di input telefono
    $(".phone").mask("(00) 0000-0000");

    // Esempio di maschera per un campo di input intero
    $(".integer").mask("0000000000", { reverse: false });

    // Maschera per soli numeri (fino a 15 cifre)
    $(".number-only").mask("000000000000000", { reverse: false });

    

    // Aggiungi altre maschere come necessario
};
// Assicurati di chiamare questa funzione all'avvio della tua applicazione
